import React, { useState, useEffect, useRef } from "react";

export const CountDownTimer = ({ 
    radius = 18, 
    strokeWidth = 2, 
    color = "#000",
    durationInSeconds = 0, 
    onTimerTimeout
    }) => {
    const [timeLeft, setTimeLeft] = useState(durationInSeconds * 1000);
    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);
    const interval = 500;
    
    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= interval) {
                    timeoutRef.current = setTimeout(() => {
                        clearInterval(intervalRef.current);
                        onTimerTimeout?.();
                    }, 1000)
                    return 0;
                }
                return prev - interval
            });
        }, interval);
        return () => clearInterval(intervalRef.current);
    }, []);

    const size = radius * 2;
    const r = radius - strokeWidth / 2;
    const c = Math.round(r * 2 * Math.PI);
    const progress = timeLeft / (durationInSeconds * 1000);
    const offset = c * (1 - progress);

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            <circle
                className="countdown-circle"
                strokeWidth={`${strokeWidth}`}
                stroke={color}
                r = {r}
                cx={radius}
                cy={radius}
                strokeDasharray={`${c} ${c}`}
                style={{ strokeDashoffset: offset }}
                fill="transparent"
                vectorEffect="non-scaling-stroke">
            </circle>
        </svg>
    )
}

export default CountDownTimer;